export default __webpack_public_path__ + "static/marc-dumais-ff2115d30d9d7fec46cd1daf6cf2ce97.jpg";